import { useEffect } from "react";
import { useLocation } from "react-router";
import { HeroSection } from "./HeroSection";
import { ProductCarouselSection } from "./ProductCarouselSection";
import { WorkshopCarouselSection } from "./WorkshopCarouselSection";
import { JournalCarouselSection } from "./JournalCarouselSection";
import { NewsletterSection } from "./NewsletterSection";
import { FAQSection } from "./FAQSection";

export function HomePage() {
  const { hash } = useLocation();

  // Scroll to section when navigating from another page with a hash
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Small delay to let sections render
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [hash]);

  return (
    <>
      <HeroSection />
      <ProductCarouselSection />
      <WorkshopCarouselSection />
      <JournalCarouselSection />
      <FAQSection />
      <NewsletterSection />
    </>
  );
}